<!-- Lead-capture trigger used on general pages, agent pages, residential listings, commercial properties, and brokerage details. -->
<template>
    <button :class="classnames" @click="openForm">
		<slot></slot>
	</button>
</template>

<script>
	export default {
		emits: [],
        props: {
            html: {
                type: String,
                default: '',
            },
            classnames: {
                type: String,
                default: 'btn btn-primary',
            },
        },
		methods: {
            openForm() {
                let modal = document.getElementById('request-showing')
                if (modal) {
                    modal.style.display = 'flex'
                }
            },
		},
	};
</script>

<style>
	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}

	.fade-enter-to,
	.fade-leave {
		opacity: 1;
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.25s ease;
	}
</style>
